'use client';

import { c as _c } from "react/compiler-runtime";
import { type ListItem, ListSelection } from '@/app/components/forms/list-selection';
import { CustomSelection } from '@/app/lcv/components/sections/calculator/configure/custom-selection';
import { formatPrice } from '@/app/utils/format';
import { safeCall } from '@/app/utils/safeCall';
import type { LcvModelWithFieldKey } from '@/services/lineup-model/lcv-product-compare/types';
import type { LcvModelSubCategory } from '@/types/tis-cms/types';
interface GradeSelectionProps {
  isOpen: boolean;
  toggle: () => void;
  modelSubCategory?: LcvModelSubCategory;
  listModel: LcvModelWithFieldKey[];
  model: LcvModelWithFieldKey;
  onSelectModel?: (model: LcvModelWithFieldKey) => void;
}
export const GradeSelection = t0 => {
  const $ = _c(17);
  const {
    isOpen,
    toggle,
    modelSubCategory,
    listModel: t1,
    model,
    onSelectModel
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const listModel = t2;
  let t3;
  if ($[2] !== listModel || $[3] !== modelSubCategory) {
    t3 = !!modelSubCategory ? listModel?.filter(item => item?.subCategory?.documentId === modelSubCategory?.documentId) : listModel;
    $[2] = listModel;
    $[3] = modelSubCategory;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const list = t3;
  let t4;
  if ($[5] !== list || $[6] !== onSelectModel || $[7] !== toggle) {
    t4 = selectedItem => {
      toggle();
      const selectedModel = list.find(item_0 => item_0.documentId === selectedItem.uid);
      if (selectedModel) {
        safeCall(onSelectModel, selectedModel);
      }
    };
    $[5] = list;
    $[6] = onSelectModel;
    $[7] = toggle;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onGradeChange = t4;
  let t5;
  if ($[9] !== isOpen || $[10] !== list || $[11] !== model || $[12] !== onGradeChange || $[13] !== toggle) {
    t5 = list?.length > 0 && <div className="cursor-pointer space-y-2" onClick={toggle}><CustomSelection test="model" title={"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E01\u0E23\u0E14"} value="accordion-grade" selectedValue={<>{model?.name}<span className="shrink-0">{formatPrice(model?.price)}</span></>} isOpen={isOpen} onChange={toggle} content={<ListSelection items={list.map(_temp)} value={model.documentId} onSelected={selectedItem_0 => onGradeChange(selectedItem_0)} />} /></div>;
    $[9] = isOpen;
    $[10] = list;
    $[11] = model;
    $[12] = onGradeChange;
    $[13] = toggle;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <>{t5}</>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
function _temp(item_1) {
  return {
    uid: item_1.documentId,
    name: item_1.name,
    price: item_1.price ?? 0
  };
}